import { observer } from 'mobx-react-lite';
import { Breadcrumbs, Typography, Link } from '@material-ui/core';
import React from 'react';
import { AdminPageLayout } from '../../components/uiComponents/UIComponents';
import { FinancialsComponent } from '../../components/financials/index';
import { IdentityVerificationGate } from '../../components/gatekeeper/IdentityVerificationGate';

export const FinancialsPage: React.FC = observer(() => {
    return (
        <AdminPageLayout
            header={
                <div>
                    <Breadcrumbs separator='›' aria-label='breadcrumb'>
                        <Link color='inherit' href='/account'>
                            Account
                        </Link>
                        <Typography color='textPrimary'>Financials</Typography>
                    </Breadcrumbs>
                    <Typography variant='h4' gutterBottom>
                        Financials
                    </Typography>
                </div>
            }
            content={
                <IdentityVerificationGate>
                    <FinancialsComponent />
                </IdentityVerificationGate>
            }
            maxWidth='md'
        />
    );
});
